import "./Manufacturing.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import ThePlantFloorBreadthProblem from "./sections/ThePlantFloorBreadthProblem";
import WhatGetsLabeledOnAPlantFloor from "./sections/WhatGetsLabeledOnAPlantFloor";
import OneSourceConsistentFloor from "./sections/OneSourceConsistentFloor";
import SafetyLabelingCompliance from "./sections/SafetyLabelingCompliance";
import HowToOrder from "./sections/HowToOrder";
import ManufacturingPlantLabelingCommonQuestions from "./sections/ManufacturingPlantLabelingCommonQuestions";
import SendYourAssetListForAQuote from "./sections/SendYourAssetListForAQuote";
import Footer from "@/reusable_sections/Footer";
export default function ManufacturingPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <ThePlantFloorBreadthProblem />
      <WhatGetsLabeledOnAPlantFloor />
      <OneSourceConsistentFloor />
      <SafetyLabelingCompliance />
      <HowToOrder />
      <ManufacturingPlantLabelingCommonQuestions />
      <SendYourAssetListForAQuote />
      <Footer />
    </div>;
}